var _ = require("lodash");
var dd = require("react-dd");
var Text = require("react-loose-forms.bootstrap3/inputs/Text").component;
var Select = require("react-loose-forms.bootstrap3/inputs/Select").component;

var getStatesForCountry = function(Displaylists, short_country){
	var u_lists = (Displaylists && Displaylists.universal) || {};
	return _.filter(u_lists.statelist, function(state){
		return state.sc == short_country;
	});
};

module.exports = {
	component: dd.createClass({
		__getOptions: function(){
			var field = this.props.field || {};
			return _.object(_.map(getStatesForCountry(field.Displaylists, field.country), function(state){
				return [state.ss, state.ls];
			}));
		},
		render: function(){
			var field = _.cloneDeep(_.omit(this.props.field, "Displaylists"));
			var options = this.__getOptions();

			if(_.isEmpty(options)){
				if(!_.isString(field.placeholder)){
					field.placeholder = "State/Province";
				}
				return Text(_.assign({}, this.props, {
					field: field
				}));
			}
			field.options = options;
			field.dont_sort_options = true;//It should come pre-sorted from the server
			if(!_.isString(field.placeholder)){
				field.placeholder = "-- select state/province --";
			}
			return Select(_.assign({}, this.props, {
				field: field
			}));
		}
	}),
	validate: function(value){
		return !!value || "Please select a state/province";
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/inputs/esState.js
// module id = 179
// module chunks = 0 1 2 3 4